import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Icon from 'components/styleguide/icon/Icon';

const styles = require('./PhoneNumberField.module.scss');

interface PhoneNumberFieldProps {
  label?: string;
  required?: boolean;
  error?: string;
  hint?: string;
  context?: 'talent' | 'company' | 'neutral';
  value?: string;
  defaultCountry?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (value: string) => void;
}

const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({
  label,
  required,
  error,
  hint,
  context = 'neutral',
  value = '',
  defaultCountry = 'pt',
  placeholder = "+351 910 000 000",
  disabled,
  onChange,
}) => {
  const handleChange = (phone: string) => {
    onChange?.(phone ? `+${phone}` : '');
  };

  return (
    <div className={styles.wrapper}>
      {label && (
        <div className={styles.labelContainer}>
          <label className={styles.label}>{label}</label>
          {required && <p className={styles.required}>*</p>}
        </div>
      )}

      <PhoneInput
        country={defaultCountry}
        value={(value || '').replace('+', '')}
        onChange={handleChange}
        disabled={disabled}
        placeholder={placeholder}
        containerClass={`${styles.container} ${error ? styles.error : ''} ${styles[context] || ''}`}
        inputClass={styles.input}
        buttonClass={styles.flagButton}
        dropdownClass={styles.dropdown}
      />

      {(error || hint) && (
        <div className={`${styles.hintContainer} ${error ? styles.hintError : ''}`}>
          <Icon
            name={error ? 'triangleAlert' : 'info'}
            color={error ? 'error' : 'disable'}
            size="sm"
          />
          <p className={styles.hintText}>{error || hint}</p>
        </div>
      )}
    </div>
  );
};

export default PhoneNumberField;
